module.exports = __webpack_public_path__ + "fonts/untitled-font-1.a4358de.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/untitled-font-1.ttf
// module id = ./src/assets/fonts/untitled-font-1.ttf
// module chunks = 34